import React, { useCallback, useEffect, useMemo, useState } from "react";
import AppEngine from "../../apps/AppEngine";
import { productsBundleMocks } from "../../../mocks/products";
import {
    BUTTON_EFFECT_OPTIONS,
    BUTTON_TEXT_OPTIONS,
    BUTTON_THICKNESS_OPTIONS,
    BUTTON_TYPE_OPTIONS,
    BUTTON_VARIANT_OPTIONS,
    CHECKBOX_TYPE_OPTIONS,
    INPUT_TYPES_OPTIONS,
    INPUT_VARIANT_OPTIONS,
    LANGUAGE_OPTIONS,
    OVERALL_TYPES_OPTIONS,
    QUERY_AND_SESSION_KEYS,
    ROUTES,
    SERVER_SIDE_CACHE_KEYS,
    WINDOW_TYPES_OPTIONS,
} from "~/constants";
import { getServerHostKey, getServerHostUrl, isDemoEnvironment, isLocalDev } from "rylak-common";
import { fetchDemoComplete, fetchDemoInit } from "~/services";
import Input from "~/components/inputs/Input";
import { Button } from "~/components/buttons/Buttons";
import demoBrandData from "~/mocks/demoBrandData";
import { getLocalMockBrandData, isBrandLocalMock, SUCCESS_CONFETTI_OPTIONS } from "../dev/DevEnvironment.core";
import SettingsComponent from "../SettingsComponent";
import { getOrderIdLabelIds } from "~/cores/brandDataCore";
import { FONTS } from "../../apps/appUtils/fonts";
import { getEmailValidators } from "~/pages/[brand]/index.core";
import _ from "lodash";
import { HOSTS, serviceIsFetched, serviceIsLoading, useServiceHook } from "rylak-common";
import { useQueryState } from "rylak-common/src/hooks/useQueryState.jsx";
import { IFRAME_ACTIONS } from "rylak-common/src/constants";
import { devFetch } from "~/app/environments/dev/devFetch.js";

function SmileyIcon() {
    return (
        <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style={{ enableBackground: "new 0 0 512 512;" }}
            xmlSpace="preserve"
        >
            <g>
                <g>
                    <path
                        d="M437.019,74.981C388.668,26.629,324.38,0,256,0S123.332,26.629,74.981,74.981C26.628,123.332,0,187.62,0,256
    s26.628,132.668,74.981,181.019C123.332,485.371,187.62,512,256,512s132.668-26.629,181.019-74.981
    C485.372,388.668,512,324.38,512,256S485.372,123.332,437.019,74.981z M256,481.524c-124.354,0-225.524-101.17-225.524-225.524
    S131.646,30.476,256,30.476S481.524,131.646,481.524,256S380.354,481.524,256,481.524z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M200.622,188.396c-24.953-24.955-65.556-24.953-90.509,0c-5.951,5.95-5.951,15.599,0,21.55
			c5.952,5.95,15.601,5.95,21.551,0c13.072-13.071,34.34-13.07,47.41,0c2.976,2.976,6.875,4.464,10.774,4.464
			s7.8-1.488,10.774-4.464C206.573,203.995,206.573,194.347,200.622,188.396z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M401.884,188.396c-24.953-24.953-65.556-24.955-90.509,0c-5.951,5.95-5.951,15.599,0,21.55
			c5.952,5.95,15.601,5.95,21.551,0c13.07-13.071,34.338-13.072,47.41,0c2.976,2.976,6.875,4.464,10.774,4.464
			s7.8-1.488,10.774-4.464C407.835,203.995,407.835,194.347,401.884,188.396z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M391.111,267.175H120.889c-8.416,0-15.238,6.823-15.238,15.238c0,82.902,67.447,150.349,150.349,150.349
			s150.349-67.447,150.349-150.349C406.349,273.997,399.527,267.175,391.111,267.175z M256,402.286
			c-60.938,0-111.402-45.703-118.909-104.635H374.91C367.402,356.583,316.938,402.286,256,402.286z"
                    />
                </g>
            </g>
        </svg>
    );
}

function TryTurnrSuccessComponent(props) {
    const { getLocaleText, email, onSubmit, demoCompleteServiceData } = props;

    const [contactFormData, setContactFormData] = useState({
        name: "",
        email: email || "",
    });
    const [validInput, setValidInput] = useState(false);
    const [validated, setValidated] = useState(false);

    const emailValidators = getEmailValidators(props);

    React.useEffect(() => {
        const foundError = emailValidators.find((v) => !v.validator(contactFormData.email));
        setValidInput(!foundError);
    }, [contactFormData]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (validInput) {
            onSubmit(contactFormData);
            setValidated(false);
        } else {
            setValidated(true);
        }
    };

    const handleNameChange = (value) => {
        setContactFormData((prevState) => ({ ...prevState, name: value }));
    };

    const handleEmailChange = (value) => {
        setContactFormData((prevState) => ({ ...prevState, email: value }));
    };
    return (
        <>
            {serviceIsFetched(demoCompleteServiceData) ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <div style={{ width: "100px", marginTop: "70px" }}>
                        <SmileyIcon />
                    </div>
                    <p
                        style={{
                            marginTop: "20px",
                            marginBottom: 0,
                            fontWeight: "bold",
                        }}
                    >
                        Vi hör av oss så snart vi kan!
                    </p>
                </div>
            ) : (
                <form style={{ height: "100%" }} onSubmit={handleSubmit}>
                    <div style={{ marginBottom: "20px", fontWeight: "bold" }}>
                        <p
                            style={{
                                paddingTop: "10px",
                                textAlign: "left",
                            }}
                        >
                            Gillar du det du ser?{" "}
                        </p>
                        <p
                            style={{
                                marginTop: "-10px",
                                marginBottom: "-1px",
                                fontWeight: "normal",
                            }}
                        >
                            Fyll i dina uppgifter nedan så kontaktar vi dig och berättar mer.
                        </p>
                    </div>
                    <div style={{ margin: "0px" }}>
                        <div style={{ marginBottom: "20px" }}>
                            <Input name="name" disabled={serviceIsLoading(demoCompleteServiceData)} value={contactFormData.name} onChange={handleNameChange} type="name" placeholder="Namn" />
                        </div>
                        <Input
                            name="email"
                            required={true}
                            disabled={serviceIsLoading(demoCompleteServiceData)}
                            value={contactFormData.email}
                            onChange={handleEmailChange}
                            type="email"
                            placeholder="Email"
                            validated={validated}
                            validators={emailValidators}
                        />
                        <div style={{ marginTop: "20px" }}>
                            <Button
                                disabled={false}
                                loading={serviceIsLoading(demoCompleteServiceData)}
                                fullWidth={true}
                                variant={validInput ? "primary" : "outline-primary"}
                                getLocaleText={getLocaleText}
                                type="submit"
                                text={"Skicka"}
                            />
                        </div>
                    </div>
                </form>
            )}
        </>
    );
}

export default function DemoEnvironment(props) {
    const { router, queryClient, Page, serverSideProps, urlHost } = props;

    const { brandName, url } = serverSideProps;

    const serverHostUrl = getServerHostUrl(url);

    const originalSystem = useMemo(
        () => ({
            fetch: fetch,
            host: serverHostUrl,
        }),
        [serverHostUrl],
    );

    const serverHostKey = getServerHostKey(url);
    const includeReturnReasons = isDemoEnvironment() || isLocalDev();
    // Retrieve the server side cached init response data
    // Is generated from getServerSideProps
    const initServiceData = queryClient.getQueryData([SERVER_SIDE_CACHE_KEYS.INIT, brandName, serverHostKey, includeReturnReasons]);
    const fromUrlBrandData = initServiceData?.data;

    const [brandData, setBrandData] = useState(getLocalMockBrandData(brandName) || fromUrlBrandData);
    const [forceIframe, setForceIframe] = useState(false);
    const [forcePhoneView, setForcePhoneView] = useState(false);
    const [forceModalIframeActive, setForceModalIframeActive] = useState(false);

    useEffect(() => {
        setBrandData(getLocalMockBrandData(brandName) || fromUrlBrandData);
    }, [brandName]);
    const [forceRealReturnReasons] = useQueryState({
        key: QUERY_AND_SESSION_KEYS.FORCE_REAL_RETURN_REASONS,
    });

    const mockedServices = true;
    const mockTimer = 500;
    const host = getServerHostKey(urlHost);

    // Helping navigate function to pre-populate brand in the query
    const navigate = useCallback(
        (url, as, options) => {
            if (_.isObject(url)) {
                return router.push(
                    {
                        ...url,
                        query: { brand: router.query.brand, ...url.query },
                    },
                    as,
                    options,
                );
            } else {
                return router.push(url, as, options);
            }
        },
        [router],
    );

    const modifiedSystem = {
        ...originalSystem,
        host: HOSTS[host]?.baseUrl,
        fetch: (...args) => {
            return devFetch(
                {
                    productsBundleMock: brandData.productsBundleMock,
                    system: originalSystem,
                    brandName: brandName,
                    mockedServices,
                    mockTimer,
                    brandData,
                    forceRealReturnReasons,
                },
                ...args,
            );
        },
    };

    // Just for logging who tried or demo purposes
    const { serviceData: demoInitServiceData, fetchServiceData: demoInitFetch } = useServiceHook({
        system: originalSystem,
        fetchRequested: false,
        fetchFn: fetchDemoInit,
    });

    const { serviceData: demoCompleteServiceData, fetchServiceData: demoCompleteFetch } = useServiceHook({
        system: originalSystem,
        fetchRequested: false,
        fetchFn: fetchDemoComplete,
    });

    useEffect(() => {
        if (!brandName) {
            navigate({
                pathname: ROUTES.MAIN_BRAND_PATH.pathname,
                query: { brand: demoBrandData().brandName },
            });
        }
    }, [brandName]);

    const listenerFunction = useCallback(
        (e) => {
            if (e.data?.action === IFRAME_ACTIONS.UPDATE_BRAND_DATA) {
                let newBrandData = e.data?.data;
                if (newBrandData?.exchangeActive !== false) {
                    newBrandData.exchangeActive = true;
                }
                setForceIframe(e.data?.forceIframe);
                setForcePhoneView(e.data?.forcePhoneView);
                setForceModalIframeActive(e?.data?.forceModalIframeActive);

                setBrandData({ ...brandData, ...newBrandData });
            }
        },
        [brandData],
    );

    useEffect(() => {
        window.addEventListener("message", listenerFunction);
        return () => {
            window.removeEventListener("message", listenerFunction);
        };
    }, [listenerFunction]);

    useEffect(() => {
        if (router.isReady) {
            window?.top?.postMessage(
                {
                    action: IFRAME_ACTIONS.INITIALIZED,
                    productsBundleMocks: Object.keys(productsBundleMocks),
                    languages: LANGUAGE_OPTIONS.map((l) => l.value),
                    successConfettiOptions: SUCCESS_CONFETTI_OPTIONS,
                    fonts: FONTS,
                    orderIdLabels: getOrderIdLabelIds(),

                    buttonVariantOptions: BUTTON_VARIANT_OPTIONS,
                    buttonTypeOptions: BUTTON_TYPE_OPTIONS,
                    buttonTextOptions: BUTTON_TEXT_OPTIONS,
                    buttonEffectOptions: BUTTON_EFFECT_OPTIONS,
                    buttonThicknessOptions: BUTTON_THICKNESS_OPTIONS,

                    inputVariantOptions: INPUT_VARIANT_OPTIONS,
                    inputTypeOptions: INPUT_TYPES_OPTIONS,
                    checkboxTypeOptions: CHECKBOX_TYPE_OPTIONS,

                    windowTypeOptions: WINDOW_TYPES_OPTIONS,
                    overallTypeOptions: OVERALL_TYPES_OPTIONS,
                },
                "*",
            );
        }
    }, [router.isReady]);

    const tryTurnr = brandName === "d-congress";
    const showSettings = isBrandLocalMock(brandName) && brandData;

    return (
        <>
            {showSettings && <SettingsComponent brandName={brandName} brandData={brandData} setBrandData={setBrandData} />}
            {brandName && brandData && (
                <AppEngine
                    isDemo={true}
                    Page={Page}
                    brandName={brandName}
                    brandData={brandData}
                    router={router}
                    forcePhoneView={forcePhoneView}
                    forceIframe={forceIframe}
                    forceModalIframeActive={forceModalIframeActive}
                    navigate={navigate}
                    system={modifiedSystem}
                    initServiceData={{
                        ...initServiceData,
                        data: brandData,
                        ...(brandData && { status: 200, error: null }),
                    }}
                    appOverrides={
                        tryTurnr && {
                            loginDescriptionOverride: <b>Skriv in din email för att testa hur returer borde fungera</b>,
                            orderId: "1234",
                            orderIdDisabled: false,
                            SuccessComponent: TryTurnrSuccessComponent,
                            successComponentProps: {
                                demoCompleteServiceData: demoCompleteServiceData,
                                onSubmit: ({ email, name }) =>
                                    demoCompleteFetch({
                                        email,
                                        name,
                                        uuid: demoInitServiceData?.data?.uuid,
                                    }),
                            },
                            onLogin: ({ email }) => demoInitFetch(email),
                        }
                    }
                />
            )}
        </>
    );
}
